import { VariantProps, cva } from 'class-variance-authority';

import { Loader } from '../assets';
import { cn } from '../lib';

const variants = cva('w-full h-full flex items-center justify-center', {
  variants: {
    size: {
      default: '[&>svg]:max-w-8 [&>svg]:max-h-8',
      sm: '[&>svg]:max-w-5 [&>svg]:max-h-5',
    },
    variant: {
      primary: '[&_path]:fill-primary',
      'contrast-500': '[&_path]:fill-[var(--color-bg-contrast-500)]',
      'surface-00': '[&_path]:fill-[var(--color-bg-surface-00)]',
    },
  },
  defaultVariants: {
    size: 'default',
    variant: 'primary',
  },
});

interface SpinnerProps extends VariantProps<typeof variants> {
  className?: string;
}

export const Spinner = ({ className, variant, size }: SpinnerProps) => {
  return (
    <div className={cn(variants({ className, variant, size }))}>
      <Loader className="animate-rotate" />
    </div>
  );
};
